import { create } from 'zustand';

const LoadingDialogDefaultState = {
    isLoadingOpen: false,
};

export const useLoadingDialogStore = create<LodingDialogType>()((set) => ({
    ...LoadingDialogDefaultState,
    action: {
        setIsLoadingOpen : (isLoadingOpen)=>set(()=>({isLoadingOpen}))
    },
}));
interface LodingDialogType {
    isLoadingOpen: boolean;
    action: {
        setIsLoadingOpen : (isLoadingOpen)=>void
    };
}
